import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useOccContext } from '../../../context/occ/hooks/use-occ-context';
import { Button } from '../../button/button';
import { ButtonColor } from '../../button/types/color';
import { ZoomControllerButtonType as ButtonType } from '../types/button-type';
const b = bemClassBuilder('v-zoom-controller-button');
export const ZoomControllerButton = props => {
    const { type, availability, isDisabled, onClick } = props;
    const { assets, accessibilityText } = useOccContext();
    return (_jsx(Button, Object.assign({ className: b.block({ type }), color: ButtonColor.Secondary, disabled: isDisabled || !availability[type], iconOnly: true, onClick: () => onClick(type) }, getPropsForType(assets, accessibilityText, type))));
};
const getPropsForType = (assets, accessibilityText, type) => {
    switch (type) {
        case ButtonType.ZoomIn:
            return {
                iconName: assets.zoomControllerZoomInButtonIconName,
                label: accessibilityText.zoomControllerZoomInButtonAriaLabel
            };
        case ButtonType.ZoomOut:
            return {
                iconName: assets.zoomControllerZoomOutButtonIconName,
                label: accessibilityText.zoomControllerZoomOutButtonAriaLabel
            };
        case ButtonType.ResetZoom:
            return {
                iconName: assets.zoomControllerResetZoomButtonIconName,
                label: accessibilityText.zoomControllerResetZoomButtonAriaLabel
            };
        case ButtonType.PanUp:
            return {
                iconName: assets.zoomControllerPanUpButtonIconName,
                label: accessibilityText.zoomControllerPanUpButtonAriaLabel
            };
        case ButtonType.PanDown:
            return {
                iconName: assets.zoomControllerPanDownButtonIconName,
                label: accessibilityText.zoomControllerPanDownButtonAriaLabel
            };
        case ButtonType.PanLeft:
            return {
                iconName: assets.zoomControllerPanLeftButtonIconName,
                label: accessibilityText.zoomControllerPanLeftButtonAriaLabel
            };
        case ButtonType.PanRight:
            return {
                iconName: assets.zoomControllerPanRightButtonIconName,
                label: accessibilityText.zoomControllerPanRightButtonAriaLabel
            };
    }
};
//# sourceMappingURL=button.js.map